module.exports = __webpack_public_path__ + "img/hic-cardiovascular-diseases-female.32d46dad.png";